<template>
  <q-header class="giscube-header">
    <q-toolbar class="giscube-toolbar">
      <a v-if="panoramaHeader ? $q.screen.gt.md : true" class="giscube-header-brand cursor-pointer" :href="brandLink"><img :src="brandLogo"><span>{{ brandText }}</span></a>
      <q-separator v-if="$q.screen.gt.md" vertical />
      <panorama-campaigns-dropdown v-if="!isMenu && panoramaHeader" :style="!$q.screen.gt.md && 'margin-left: -15px'" :isHeader="true" :isMenu="false"/>
      <q-separator vertical v-if="!isMenu && panoramaHeader" />
      <q-btn
        flat dense
        v-if="isMenu && panoramaHeader"
        icon="drag_indicator"
      >
        <q-menu>
          <panorama-tools :isHeader="true"/>
        </q-menu>
      </q-btn>
      <panorama-tools v-else-if="panoramaHeader" :isHeader="true"/>
      <q-space/>
      <auth-header-item :isPanoramaHeader="panoramaHeader"/>
      <panorama-options-dropdown v-if="panoramaHeader" :isHeader="true" :isMenu="isMenu"/>
    </q-toolbar>

  </q-header>
</template>

<script>
import AuthHeaderItem from './AuthHeaderItem.vue'
import PanoramaCampaignsDropdown from 'components/Panorama/PanoramaCampaignsDropdown.vue'
import PanoramaTools from 'components/Panorama/PanoramaTools.vue'
import PanoramaOptionsDropdown from 'components/Panorama/PanoramaOptionsDropdown.vue'
import { QBtn, QHeader, QMenu, QSeparator, QSpace, QToolbar } from 'quasar'

export default {
  props: [
    'brandLogo',
    'brandText'
  ],
  components: {
    AuthHeaderItem,
    PanoramaCampaignsDropdown,
    PanoramaTools,
    PanoramaOptionsDropdown,
    QBtn,
    QHeader,
    QMenu,
    QSeparator,
    QSpace,
    QToolbar
  },
  data () {
    return {
      brandLink: '/'
    }
  },
  computed: {
    panoramaHeader () {
      return this.$store.state.basicLayout.panoramaHeader
    },
    isMenu () {
      return this.$q.screen.lt.sm
    }
  },
  methods: {
  }
}
</script>

<style>
</style>
